import React, { forwardRef, useRef } from "react";
import EpisodeCard from "../VideoCard/VideoCard";
import "./RecommendedRow.css"
const RecommendedRow = forwardRef(({ category }, ref) => {
  const episodeRefs = useRef([]);

  const h1Style = {
    fontSize: "4vw", // scalable text
    lineHeight: 1, // prevent overflow
    margin: 0,
    textAlign: "center",
    fontWeight: "bold"
  };

  return (
    <div
      className="row m-0 recommendedRow">
      <div className="col-6">
        {category.series?.[0] && category.series[0].episodes?.[0] && (
          <EpisodeCard
            episode={category.series[0].episodes[0]}
            series={category.series[0]}
            ref={(el) => el && episodeRefs.current.push(el)}
          />
        )}
      </div>
      <div className="col-6 rightColStyle">
        {category.series?.[0] && category.series[0].episodes?.[0] && (
          <h1 style={h1Style}>
            {category.series[0].episodes[0].episode_title}
          </h1>
        )}
      </div>
    </div>
  );
});

export default RecommendedRow;
